export default __webpack_public_path__ + "static/bluedot_studio_shot-e2be73db2968f74f7d51bc025c20d952.jpg";